<template>

<v-card
  class="app-center"
>
  <v-toolbar
    color="light-blue lighten-1"
    cards
    dark
    flat
    height="70px">

    <v-card-title class="title font-weight-regular">Address Book</v-card-title>
    <v-spacer></v-spacer>
    <v-btn large color="light-blue darken-2" router-link to="/add-address">
      new
    </v-btn>
  </v-toolbar>

  <v-alert
    :value="true"
    color="warning"
    icon="priority_high"
    v-if="addressBook.length == 0"
  >
    No records yet, add first one now...
  </v-alert>

  <div v-if="addressBook.length > 0" class="address-wrap">
    <v-expansion-panel popout>
      <v-expansion-panel-content
        v-for="(record,i) in addressBook"
        :key="i"
        >
        <div slot="header"><strong>{{ record.surname }}, {{ record.first_name }}</strong></div>
        <v-card>
          <v-card-text>
            <div>{{ record.address }}</div>
            <div>{{ record.city }}</div>
            <div>{{ record.postcode }}</div>
            <div>{{ record.country }}</div>

            <br>

            <div>{{ record.note }}</div>
          </v-card-text>

          <v-card-actions>

            <v-btn flat small color="error" router-link :to="'/delete-record/' + record.id">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark outline color="light-blue darken-2" @click="editAddress(record.id)">Edit</v-btn>

          </v-card-actions>

        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>

</v-card>

</template>

<script>

export default {
  data () {
    return {
      dialog: false,
      deleteId: null
    }
  },
  computed: {
    addressBook () {
      return this.$store.getters.sortedAddressBook
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    editAddress (id) {
      this.$router.push('edit-address/' + id)
    },
    onDismiss () {
      console.log('dismissed')
    }
  },
  watch: {
    dialog () {
      if (this.dialog === false) {
        this.deleteId = null
      }
    }
  }
}

</script>

<style>

</style>
